import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Modal from '@material-ui/core/Modal';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import 'moment/locale/pt-br';
import moment from 'moment';
import { instanceAxios } from '../../InstanceAxios';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import {
  formatDate2,
  formatMoney,
  onlyNumbersDotCromma,
  convertToCent,
} from '../../utils/common';
import HeadTable from '../../components/HeadTable';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import FilterIcon from '@material-ui/icons/FilterList';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    width: '95%',
  },
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    top: `50%`,
    left: `50%`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function Cupons() {
  const classes = useStyles();
  const [ready, setReady] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [filterText, setFilterText] = useState('');
  const [columnId, setColumnId] = useState('');
  const [originalCupons, setOriginalCupons] = useState([]);
  const [cupons, setCupons] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [idCupom, setIdCupom] = useState(null);
  const [cupom, setCupom] = useState('');
  const [tipoCupom, setTipoCupom] = useState('');
  const [qtdMeses, setQtdMeses] = useState(0);
  const [valor, setValor] = useState(0);
  const [qtdMaxima, setQtdMaxima] = useState(0);
  const [dtInicio, setDtInicio] = useState('');
  const [dtFim, setDtFim] = useState('');
  const [columns, setColumns] = useState([
    { id: 'id', label: '#', minWidth: 70, filterable: true },
    { id: 'cupom', label: 'Cupom', minWidth: 140, filterable: true },
    { id: 'tipo_utilizacao', label: 'Tipo', minWidth: 140, filterable: true },
    { id: 'valor', label: 'Valor', minWidth: 80, filterable: true },
    {
      id: 'data_inicio',
      label: 'Data Início',
      minWidth: 140,
      filterable: true,
    },
    { id: 'data_fim', label: 'Data Fim', minWidth: 140, filterable: true },
    { id: 'qtdMeses', label: 'Meses', minWidth: 140, filterable: true },
    {
      id: 'quantidade_maxima',
      label: 'Quantidade Cupons',
      minWidth: 70,
      filterable: true,
    },
    { id: 'edit', label: '', minWidth: 70, filterable: false },
  ]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [idOrder, setIdOrder] = useState('');
  const [order, setOrder] = useState('asc');
  const [count, setCount] = useState(0);
  const [valid, setValid] = useState(false);
  const [textoSwitch, setTextSwitch] = useState('Todos Cupons');
  const [busca, setBusca] = useState('');

  const clickAlert = () => {
    setAlert(false);
    setAlertType('');
    setMessage('');
  };

  const setCupomObj = (obj) => {
    setIdCupom(obj.id);
    setCupom(obj.cupom);
    setTipoCupom(obj.tipo_utilizacao);
    setQtdMeses(obj.qtdMeses);
    setValor((obj.valor / 100).toString());
    setQtdMaxima(obj.quantidade_maxima);
    setDtInicio(formatDate2(obj.data_inicio));
    setDtFim(formatDate2(obj.data_fim));
  };

  const getCupomObj = () => {
    if (cupom && tipoCupom && valor && qtdMaxima && dtInicio && dtFim) {
      return {
        id: idCupom,
        cupom,
        tipo_utilizacao: tipoCupom,
        qtdMeses: Number(qtdMeses),
        valor:
          typeof valor === 'string'
            ? Number(convertToCent(valor))
            : valor * 100,
        quantidade_maxima: Number(qtdMaxima),
        data_inicio: moment(dtInicio).format('YYYY-MM-DD'),
        data_fim: moment(dtFim).format('YYYY-MM-DD'),
        d1: dtInicio,
      };
    }
    return null;
  };

  const getEmptyObj = () => {
    return {
      id: undefined,
      cupom: '',
      tipo_utilizacao: '',
      qtdMeses: 0,
      valor: 0,
      quantidade_maxima: 0,
      data_inicio: '',
      data_fim: '',
    };
  };

  const handleOpen = (cupom, isEdit) => {
    setIsEdit(isEdit);
    setCupomObj(cupom);
    setOpen(true);
  };

  const handleClose = () => {
    setIsEdit(false);
    setCupomObj(getEmptyObj());
    setOpen(false);
  };

  const handleSalvar = async () => {
    const cupom = getCupomObj();
    console.log(cupom.valor);
    if (!cupom) {
      setAlert(true);
      setAlertType('error');
      setMessage('Preencha todos os Dados!');
      return;
    }
    if (isEdit) {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .put(`/cupom`, cupom)
        .then((res) => {
          setAlert(true);
          setOpen(false);
          setAlertType('success');
          setMessage('Cupom Editado com sucesso!');
          fetchCupons(limit, page, idOrder, order, valid, busca);
        })
        .catch((err) => {
          console.log(err);
          setAlert(true);
          setOpen(false);
          setAlertType('error');
          setMessage(err.message);
        });
    } else {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .post(`/cupom`, cupom)
        .then((res) => {
          setAlert(true);
          setOpen(false);
          setAlertType('success');
          setMessage('Cupom Criado com sucesso!');
          fetchCupons(limit, page, idOrder, order, valid, busca);
        })
        .catch((err) => {
          console.log(err);
          setAlert(true);
          setOpen(false);
          setAlertType('error');
          setMessage(err.message);
        });
    }
  };

  const handleDelete = async () => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .delete(`/cupom/${idCupom}`)
      .then((res) => {
        setAlert(true);
        setOpen(false);
        setAlertType('success');
        setMessage('Cupom Excluido com sucesso!');
        fetchCupons(limit, page, idOrder, order, valid, busca);
      })
      .catch((err) => {
        console.log(err);
        setAlert(true);
        setOpen(false);
        setAlertType('error');
        setMessage(err.message);
      });
  };

  const fetchCupons = async (l, p, io, o, v, b) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(
        `/cupom?limit=${l}&p=${p}&campoOrdenacao=${io}&ordem=${o}&valid=${v}&busca=${b}`
      )
      .then((res) => {
        const rows = Array.isArray(res?.data?.rows) ? res.data.rows : [];

        setCupons(rows);
        setOriginalCupons(rows);
        setCount(res?.data?.count || 0);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setReady(true);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchCupons(limit, newPage, idOrder, order, valid, busca);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setLimit(event.target.value);
    fetchCupons(event.target.value, 0, idOrder, order, valid, busca);
  };

  const handleValid = () => {
    const v = !valid;
    setPage(0);
    setTextSwitch(v ? 'Cupons Ativos' : 'Todos Cupons');
    setValid(v);
    fetchCupons(limit, 0, idOrder, order, v, busca);
  };

  const setIdOrderUpdate = (id) => {
    let o;
    // Checando se é o mesmo atual
    if (id === idOrder) {
      o = order === 'asc' ? 'desc' : 'asc';
      setOrder(o);
    } else {
      o = 'asc';
      setIdOrder(id);
    }
    fetchCupons(limit, page, id, o, valid, busca);
  };

  const handleBusca = (text) => {
    setBusca(text);
    setPage(0);
    fetchCupons(limit, 0, idOrder, order, valid, text);
  };

  useEffect(() => {
    fetchCupons(10, 0, '', '', false, '');
  }, []);

  const openModalFilter = (event, columnid) => {
    setFilterText('');
    const rect = event.target.getBoundingClientRect();
    setIsModalOpen(true);
    setModalPosition({ top: rect.top, left: rect.left });
    setColumnId(columnid);
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  // Function to filter the table data
  const filterTable = () => {
    setIsModalOpen(false);

    const filteredDas = originalCupons.filter((item) => {
      const value = getValueColumnId(columnId, item);
      return (
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    });
    // Update the table data with filtered data
    setCupons(filteredDas);
  };

  const getValueColumnId = (columnIdAux, rowData) => {
    columnIdAux = columnIdAux.replace(/"/g, '');

    const parts = columnIdAux.split('.');

    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    return result;
  };

  const clearFilter = () => {
    setIsModalOpen(false);
    setFilterText('');
    setCupons(originalCupons);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRequestSort = (property) => {
    const orderBy = property;

    if (idOrder === property && order === 'desc') {
      setOrder('asc');
    } else {
      setOrder('desc');
    }

    setIdOrder(orderBy);
  };

  const sortTable = (property) => {
    const isAsc = order === 'asc';
    const cuponsOrdenados = Array.isArray(cupons) ? [...cupons] : [];

    cuponsOrdenados.sort((a, b) => {
      let aValue = getValueColumnId(property, a);
      let bValue = getValueColumnId(property, b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    setCupons(cuponsOrdenados);
  };

  return (
    <>
      <Modal
        open={isModalOpen}
        onClose={closeModal}
        style={{ top: modalPosition.top, left: modalPosition.left }}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '5px',
            width: '300px',
          }}
        >
          <TextField
            label="Filtrar"
            variant="outlined"
            value={filterText}
            onChange={handleFilterTextChange}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={filterTable}
            style={{ marginTop: '10px' }}
          >
            Filtrar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={clearFilter}
            style={{ marginTop: '10px', marginLeft: '5px', width: 70 }}
          >
            Limpar
          </Button>
        </div>
      </Modal>
      <Collapse in={alert}>
        <Alert severity={alertType} onClick={clickAlert}>
          {message}
        </Alert>
      </Collapse>
      <Paper>
        <Collapse in={ready}>
          <Grid
            container
            style={{ paddingLeft: 10, paddingRight: 10, paddingTop: '1%' }}
          >
            <Grid item xs={4}>
              <h1>Cupons de Desconto</h1>
            </Grid>
            <Grid item xs={4}>
              <div align="center">
                <Button
                  variant="contained"
                  startIcon={<AddCircleIcon />}
                  style={{
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                  }}
                  size="large"
                  onClick={() => handleOpen(getEmptyObj(), false)}
                >
                  Novo
                </Button>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div align="right">
                <TextField
                  id="busca"
                  label="Cupom"
                  value={busca}
                  onChange={(event) => handleBusca(event.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={valid}
                      onChange={handleValid}
                      color="primary"
                    />
                  }
                  label={textoSwitch}
                />
              </FormGroup>
            </Grid>
          </Grid>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <TableSortLabel
                        active={idOrder === column.id}
                        direction={idOrder === column.id ? order : 'asc'}
                        onClick={() => {
                          handleRequestSort(column.id);
                          setTimeout(() => {
                            sortTable(column.id);
                          }, 200);
                        }}
                      >
                        {column.label}
                      </TableSortLabel>

                      {true && (
                        <IconButton
                          style={{ marginLeft: -5 }}
                          onClick={(event) => openModalFilter(event, column.id)}
                          aria-label="filtra"
                        >
                          <FilterIcon style={{ width: 16, height: 16 }} />
                        </IconButton>
                      )}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(Array.isArray(cupons) ? cupons : []).map((c) => {
                return (
                  <TableRow key={c.id}>
                    <TableCell component="th" scope="row">
                      {c.id}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {c.cupom}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {c.tipo_utilizacao}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {formatMoney(c.valor / 100)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {c.data_inicio}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {c.data_fim}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {c.qtdMeses
                        ? `${c.qtdMeses} Meses`
                        : 'Sem Limite de Meses'}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {c.quantidade_maxima}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        onClick={() => handleOpen(c, true)}
                        style={{
                          color: XMEI_PRIMARY_COLOR,
                        }}
                        aria-label="Editar Cupom"
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                component="div"
                style={{ backgroundColor: '#FFF' }}
                rowsPerPageOptions={[5, 10, 25]}
                count={count}
                rowsPerPage={limit}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Linhas por página"
              />
            </TableRow>
          </TableFooter>
        </Collapse>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </Paper>

      <Modal className={classes.modal} open={open} onClose={handleClose}>
        <Grid container spacing={3} className={classes.paper}>
          <Collapse in={alert}>
            <Alert severity={alertType} onClick={clickAlert}>
              {message}
            </Alert>
          </Collapse>
          <Grid item xs={12}>
            <h2>Dados do Cupom</h2>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="cupom"
                  label="Cupom"
                  variant="outlined"
                  value={cupom}
                  onChange={(event) => setCupom(event.target.value)}
                  disabled={isEdit}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  id="tipoCupom"
                  variant="outlined"
                  select
                  label="Tipo Cupom"
                  value={tipoCupom}
                  onChange={(event) => setTipoCupom(event.target.value)}
                >
                  <MenuItem key="ASSINATURA" value="ASSINATURA">
                    Assinatura
                  </MenuItem>
                  <MenuItem key="SERVIÇOS" value="SERVIÇOS">
                    Serviços
                  </MenuItem>
                  <MenuItem key="GENÉRICO" value="GENÉRICO">
                    Genérico
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  id="qtdMeses"
                  variant="outlined"
                  label="Quantidade de Meses"
                  type="number"
                  value={qtdMeses}
                  onChange={(event) => setQtdMeses(event.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="valor"
                  variant="outlined"
                  label="Valor"
                  value={valor}
                  onChange={(data) => {
                    const v = onlyNumbersDotCromma(data.target.value);
                    if (Number(v) < 0) {
                      setValor('0');
                    } else if (Number(data.target.value) > 999.99) {
                      setValor('999.99');
                    } else {
                      setValor(data.target.value);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="quantidade_maxima"
                  label="Quantidade Maxima"
                  type="number"
                  variant="outlined"
                  value={qtdMaxima}
                  onChange={(event) => setQtdMaxima(event.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="dtIncio"
                  label="Data Início"
                  type="date"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={dtInicio}
                  defaultValue={dtInicio}
                  onChange={(event) => setDtInicio(event.target.value)}
                  disabled={isEdit}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="dtIncio"
                  label="Data Fim"
                  type="date"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={dtFim}
                  defaultValue={dtFim}
                  onChange={(event) => setDtFim(event.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <Collapse in={isEdit}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleDelete}
                    startIcon={<DeleteIcon />}
                  >
                    Excluir
                  </Button>
                </Collapse>
              </Grid>
              <Grid item xs={6}>
                <div align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSalvar}
                    startIcon={<SaveIcon />}
                  >
                    Salvar
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

export default Cupons;
